import api from "../api/api";
import { QueryAction } from "../enums/action.enum";
import { ApiTypeEnum } from "../enums/api-type.enum";
import { ADDFEEDBACKMUTATION, TRANSACTIONMUTATION } from "../graphql/mutations/transaction.mutation";
import { TRANSACTIONQUERY } from "../graphql/queries/transactions.query";

interface queryProps {
  id: string;
  limit?: number;
}

export const createTransactionService = (
  isBankFound = false,
  transactionDetail,
  user
) => {
  return api.call({
    type: ApiTypeEnum.Transaction,
    requiresToken: true,
    data: {
      ...transactionDetail,
    },
    action: !isBankFound
      ? QueryAction.CREATE_TRANSACTION_PAYMENT_REQUEST
      : QueryAction.CREATE_TRANSACTION_BANK_TRANSFER,
    query: TRANSACTIONMUTATION,
    extraData: {
      userId: user.id,
      accountName: user.accounts[0].accountName,
      firstName: user.firstName,
      lastName: user.lastName,
      username: user.username,
    },
  });
};

export const getTransactionService = ({ id, limit }: queryProps) => {
  return api.call({
    requiresToken: true,
    data: {
      userId: id,
    },
    refine: {
      limit,
      orderBy: "creationDateTime",
      direction: "DESC",
    },
    query: TRANSACTIONQUERY,
    action: QueryAction.GET,
  });
};

export const payWithCardService = async (transactionDetail, user) => {
  try {
    const response = await api.call({
      type: ApiTypeEnum.Transaction,
      requiresToken: true,
      data: {
        ...transactionDetail,
      },
      action: QueryAction.CREATE_TRANSACTION_PAYMENT_GATEWAY,
      query: TRANSACTIONMUTATION,
      extraData: {
        userId: user.id,
        accountName: user.accounts[0].accountName,
        firstName: user.firstName,
        lastName: user.lastName,
        username: user.username,
      },
    });
    if (response.data.data.transaction.object) {
      return JSON.parse(response.data.data.transaction.object);
    }
  } catch (error: any) {
    console.log(error.response.data);
  }
};

export const addFeedBackService = async (payload) => {
  try {
    const response = await api.call({
      requiresToken: false,
      data: {
        ...payload
      },
      type: ApiTypeEnum.Other,
      action: QueryAction.GET,
      query: ADDFEEDBACKMUTATION,
      
    });
    if (response?.data?.data?.updateTransactionWithUserFeedback) {
      return response.data.data.updateTransactionWithUserFeedback
    }
  } catch (error: any) {
    console.log(error.response.data);
  }
};
